import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "../AddWorkReport/work_report.css";
import DataTable from "../../components/custom_data_table";
import {
  getReport,
  getAllAssignedProjects,
} from "../../service/project_service";
import CustomLoadingindicator from "../../components/custom_loading";

const MyReports = () => {
  const [projects, setProjects] = useState([]);
  const [workReports, setWorkReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [projectid, setProjectId] = useState(0);

  useEffect(() => {
    fetchInitialData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchInitialData = async () => {
    setLoading(true);
    try {
      const projectsRes = await getAllAssignedProjects();
      if (projectsRes?.status === "success") {
        setProjects(projectsRes.data || []);
      }
      await fetchReports("", "", 0);
    } catch (err) {
      toast.error(err?.message || "Failed to load projects");
    } finally {
      setLoading(false);
    }
  };

  const fetchReports = async (sDate, eDate, pid) => {
    setLoading(true);
    try {
      const reportsRes = await getReport({
        startDate: sDate,
        endDate: eDate,
        projectid: pid,
      });

      if (reportsRes?.status === "success") {
        const reports = reportsRes.data || [];
        const formattedReports = reports.map((report, index) => ({
          sno: index + 1,
          reportid: report.reportid,

          projectName:
            report.projectname || report.project?.projectname || "N/A",

          moduleName:
            report.modulename ||
            report.module_name ||
            report.module?.modulename ||
            "N/A",

          workDate: report.workdate || "",

          startTime: report.starttime || "-",
          endTime: report.endtime || "-",

          duration: (() => {
            const val = Number(report.workinghours) || 0;
            const h = Math.floor(val);
            const m = Math.round((val - h) * 100);
            if (h === 0 && m === 0) return "0 hrs";
            let str = "";
            if (h > 0) str += `${h} hr${h > 1 ? "s" : ""} `;
            if (m > 0) str += `${m} min${m > 1 ? "s" : ""}`;
            return str.trim();
          })(),

          notes: report.taskname || "-",
        }));

        setWorkReports(formattedReports);
      }
    } catch (err) {
      toast.error(err?.message || "Failed to load reports");
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (startDate && endDate && new Date(endDate) < new Date(startDate)) {
      toast.error("End date cannot be earlier than start date");
      return;
    }
    fetchReports(startDate, endDate, projectid);
  };

  const filteredReports = workReports;

  const handleResetFilters = (e) => {
    e.preventDefault();
    setProjectId(0);
    setStartDate("");
    setEndDate("");
    fetchReports("", "", 0);
  };

  const reportColumns = [
    { key: "sno", label: "S.No" },
    { key: "projectName", label: "Project" },
    {
      key: "moduleName",
      label: "Module Name",
      render: (value) => value || "N/A",
    },
    {
      key: "workDate",
      label: "Work Date",
      render: (value) =>
        value ? new Date(value).toLocaleDateString("en-GB") : "-",
    },
    { key: "startTime", label: "Start Time" },
    { key: "endTime", label: "End Time" },
    { key: "duration", label: "Duration" },
    { key: "notes", label: "Work Notes" },
  ];

  if (loading) {
    return <CustomLoadingindicator />;
  }

  return (
    <div className="add-report-container">
      <h4>My Work Reports</h4>

      <div className="add-report-card">
        <form className="add-report-form" onSubmit={handleSearch}>
          <div className="report-form-group">
            <label>Project</label>
            <select
              name="project_list"
              value={projectid}
              onChange={(e) => setProjectId(e.target.value)}
            >
              <option value={0}>All Projects</option>
              {projects.map((item) => (
                <option key={item.projectid} value={item.projectid}>
                  {item.projectname}
                </option>
              ))}
            </select>
          </div>

          <div className="report-form-group">
            <label>Start Date</label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>

          <div className="report-form-group">
            <label>End Date</label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>
        </form>

        <div className="submit-buttons">
          <button className="apply-btn" onClick={handleSearch}>
            Search
          </button>
          <button className="reset-btn" onClick={handleResetFilters}>
            Reset
          </button>
        </div>
      </div>

      <div style={{ height: 20 }}></div>

      <DataTable
        columns={reportColumns}
        data={filteredReports}
        loading={loading}
        pageSize={10}
      />
    </div>
  );
};

export default MyReports;
